const threshold = 0.01;

export const formatNumber = (value: number, fractionDigits = 2) => {
  if (fractionDigits && threshold > value && value > 0) {
    return `<${threshold}`;
  }

  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};
